/**
 * Where a form sends its submission.
 *
 * On a deployment that runs the Next server this is simply the site's own `/api/lead`. A
 * static export has no server of its own — UAT is a folder of files served by IIS — so that
 * build is given the absolute URL of a deployment that does, through
 * `NEXT_PUBLIC_LEAD_ENDPOINT` at build time. The endpoint answers CORS preflights for the
 * origins listed in the route itself, so a cross-origin post from UAT is allowed and nothing
 * else is.
 *
 * `NEXT_PUBLIC_FORM_DISABLED` keeps the old escape hatch: an empty endpoint makes every form
 * simulate a successful send without posting anywhere, which is what preview builds want.
 */
export const LEAD_ENDPOINT = process.env.NEXT_PUBLIC_FORM_DISABLED
  ? ""
  : process.env.NEXT_PUBLIC_LEAD_ENDPOINT || "/api/lead";
